const STORAGE_KEY = "credit_copilot_conversation_prefs";

export function emptyConversationPrefs() {
  return { starred: [], deleted: [] };
}

export function conversationId(conversation) {
  if (!conversation || conversation.id == null || conversation.id === "") {
    return "";
  }
  const partner =
    conversation.partner_id == null ? "" : String(conversation.partner_id);
  return partner ? `${partner}:${conversation.id}` : String(conversation.id);
}

export function normalizeConversationPrefs(value) {
  const starred = Array.isArray(value && value.starred)
    ? value.starred.map(String).filter(Boolean)
    : [];
  const deleted = Array.isArray(value && value.deleted)
    ? value.deleted.map(String).filter(Boolean)
    : [];
  const deletedSet = new Set(deleted);
  return {
    starred: [...new Set(starred.filter((id) => !deletedSet.has(id)))],
    deleted: [...deletedSet],
  };
}

export function loadConversationPrefs(storage) {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) {
      return emptyConversationPrefs();
    }
    return normalizeConversationPrefs(JSON.parse(raw));
  } catch (error) {
    return emptyConversationPrefs();
  }
}

export function saveConversationPrefs(prefs, storage) {
  const normalized = normalizeConversationPrefs(prefs);
  storage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function toggleStarredId(prefs, id) {
  const key = String(id || "");
  const normalized = normalizeConversationPrefs(prefs);
  if (!key || normalized.deleted.includes(key)) {
    return normalized;
  }
  const starred = normalized.starred.includes(key)
    ? normalized.starred.filter((item) => item !== key)
    : [key, ...normalized.starred];
  return { ...normalized, starred };
}

export function deleteConversationId(prefs, id) {
  const key = String(id || "");
  const normalized = normalizeConversationPrefs(prefs);
  if (!key) {
    return normalized;
  }
  return normalizeConversationPrefs({
    starred: normalized.starred,
    deleted: [...normalized.deleted, key],
  });
}

export function splitStarredConversations(conversations, prefs) {
  const normalized = normalizeConversationPrefs(prefs);
  const deleted = new Set(normalized.deleted);
  const starredOrder = new Map(
    normalized.starred.map((id, index) => [id, index])
  );
  const starred = [];
  const rest = [];

  (conversations || []).forEach((conversation) => {
    const id = conversationId(conversation);
    if (id && deleted.has(id)) {
      return;
    }
    if (id && starredOrder.has(id)) {
      starred.push(conversation);
    } else {
      rest.push(conversation);
    }
  });

  starred.sort(
    (a, b) => starredOrder.get(conversationId(a)) - starredOrder.get(conversationId(b))
  );

  return { starred, rest };
}
